import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import {
    adminNavigationItems,
    navigationItems,
} from './navigation-data.config';
import configurationData from 'assets/configuration.json';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        let admin = localStorage.getItem('isAdmin') === 'true' ? true : false;
        const loggedInUser = JSON.parse(
            localStorage.getItem('loggedInUser') || '{}',
        );
        const orgId = loggedInUser.org_id as string;
        const configuration = configurationData as Record<string, any>;

        const navItemsChildren = navigationItems[0].children?.filter((item) => {
            if (item.id === 'Tracking Module Beta') {
                return (
                    configuration['trackingModuleBeta'][orgId] ||
                    configuration['trackingModuleBeta']['default']
                );
            }
            if (item.id === 'IE Anomalies') {
                return (
                    configuration['ieAnomalies'][orgId] ||
                    configuration['ieAnomalies']['default']
                );
            }
            return true;
        });

        const navItems = [
            { ...navigationItems[0], children: navItemsChildren },
        ];

        // localStorage.
        let nav: Navigation;
        if (admin) {
            nav = {
                compact: adminNavigationItems,
                futuristic: adminNavigationItems,
                horizontal: adminNavigationItems,
                default: adminNavigationItems,
            };
        } else {
            nav = {
                compact: navItems,
                futuristic: navItems,
                horizontal: navItems,
                default: navItems,
            };
        }
        this._navigation.next(nav);
        return Observable.create((observer: any) => {
            observer.next(nav);
            //call complete if you want to close this stream (like a promise)
            observer.complete();
        });

        // return this._httpClient.get<Navigation>('api/common/navigation').pipe(
        //     tap((navigation) => {
        //         console.log(navigation);
        //         this._navigation.next(nav);
        //     })
        // );
    }
}
